<template>
  <div>
    <component :is="componentFile" />
  </div>
</template>
<script>
export default {
  computed: {
    componentFile() {
      return () => import(`./release/${this.$route.params.name}.vue`);
    },
    errorFile() {
      return () => import(`./NotFound.vue`);
    },
  },
  metaInfo() {
    return {
      title: this.textEllipsis(`News`, 25),
    };
  },
};
</script>
